module.exports = __webpack_public_path__ + "img/default-thumbnail.c5a00375.jpg";